import { useStripe } from '@stripe/react-stripe-js';
import React, { useContext, useState } from 'react';
import { TranslationContext } from "../contexts/TranslationContext";
import API_BASE_URL from '../apiConfig';

import Swal from "sweetalert2";

const PaymentForm = ({ onSuccess }) => {
  const { translations } = useContext(TranslationContext);
  const stripe = useStripe();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

const handleSubmit = async (event) => {
  event.preventDefault();
  setLoading(true);

  const token = localStorage.getItem("token");
  if (!token) {
    Swal.fire({
      icon: "warning",
      title: "Authentication Required",
      text: "User is not authenticated. Please log in.",
    });
    setLoading(false);
    return;
  }

  try {
    const paymentData = {
      plan: "monthly",
      amount: "15.99",
    };

    const response = await fetch(
      `${API_BASE_URL}/api/user/subscribe?locale=${localStorage.getItem('selectedLanguage')}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(paymentData),
      }
    );

    const result = await response.json();
    if (result.url) {
      Swal.fire({
        icon: "info",
        position: "top-end", 
        toast: true,
        title: translations.redirectingPayment,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      setTimeout(() => {
        window.location.href = result.url;
      }, 1500);
    } else if (result.success) {
      Swal.fire({
        icon: "success",
        position: "top-end", 
        toast: true, 
        title: translations.paymentSuccess,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      onSuccess(result.renewDate); // Assuming `renewDate` exists in response
    } else {
      Swal.fire({
        icon: "error",
        title: "Payment Failed",
        text: result.message || "An unknown error occurred.",
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "An error occurred: " + error.message,
    });
  }

  setLoading(false);
};


  return (
    <form onSubmit={handleSubmit}>
      <button
        className="btn btn-light bgprimary border-0 premiumMention_btn p-3 text-uppercase rounded-pill text-white fw-bold mb-3"
        type="submit"
        disabled={loading}
      >
        {loading ? (
          <>
            {translations.processing}
          </>
        ) : (
          "stripe"
        )}
      </button>
      <p className='text-white fw-500' style={{ fontSize: "14px" }}>{translations.suecurePayment} <i className="ri-lock-fill" style={{ color: "#fff" }}></i></p>
      {message && <p className='text-warning'>{message}</p>}
      <p className='strip_terms text-center mb-0'>{translations.paymentTerms} <br /> {translations.paymentTerms2}</p>

    </form>
  );
};

export default PaymentForm;
